import React, { useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import JwtDecode from 'jwt-decode';
import ReCAPTCHA from 'react-google-recaptcha';

import { constants as sessionConstants } from '../../redux/session';
import { makePost } from '../../api/ajax';
import { routes } from '../../routes/Routes';
import { PageTitle } from '../../components';
import { EmptyPage } from '../../layouts';
import { authenticationService } from '../../services';
import { getSearchParam } from '../../utils/url';

const ConfirmEmail = () => {
  const history = useHistory();
  const location = useLocation();

  const { search, hash } = location;
  const userId = getSearchParam(search, 'userId');
  const legacyAccessToken = getSearchParam(search, 'accessToken');
  const accessToken = legacyAccessToken || getSearchParam(hash.substring(1), 'token');

  const expiresAt = legacyAccessToken ? JwtDecode(legacyAccessToken).exp : Number(getSearchParam(search, 'exp'));
  const isTokenExpired = new Date(expiresAt * 1000) < Date.now();

  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [error, setError] = useState(isTokenExpired ? 'This link has expired. Please contact your provider for a new confirmation link.' : '');

  const handleRecaptchaChange = (captchaToken) => {
    if (captchaToken === null || isAuthenticating) {
      return;
    }

    setIsAuthenticating(true);

    makePost(`session/${userId}`, {
      token: accessToken,
      loginType: sessionConstants.ONE_TIME_LOGIN_TYPE.EMAIL_CONFIRMATION,
      captchaToken,
    }).subscribe(
      ({ response }) => {
        authenticationService.storeUserData(response);

        let to = routes.home;

        if (response.representatives && response.representatives.filter((rep) => !rep.isHome).length > 0) {
          to = routes.representative;
        } else if (response.askAdditionalInformation) {
          to = routes.askAdditionalInformation;
        }

        history.replace(to);
      },
      (error) => {
        if (error.status === 401) {
          setError('This link has already been used.');
          setIsAuthenticating(false);
        } else throw error;
      }
    );
  };

  return (
    <EmptyPage currentRoute={routes.account}>
      <PageTitle>
        <PageTitle.Left headingText="Email confirmation" />
      </PageTitle>
      <div className="jumbotron">
        {
          error.length > 0
            ? <p style={{ color: 'red' }}>{error}</p>
            : <p>Please check the box to continue</p>
        }
        {!isTokenExpired
          ? (
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleRecaptchaChange}
            />
          )
          : (
            <Link exact to={routes.home} className="btn btn-primary">
              Log in
            </Link>
          )}
      </div>
    </EmptyPage>
  );
};

export default ConfirmEmail;
